var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OTabItem',{attrs:{"label":_vm.label,"value":_vm.value,"item-class":"segment","icon":_vm.icon,"tag":'a'}})}
var staticRenderFns = []

export { render, staticRenderFns }